import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid } from '@mui/material'
import i18n from '../../../../simple-react-i18n'
import Input from '../../../../components/forms/Input'
import { ShapeDataType } from '../../../../administration/shapes/AdminShapes'
import { DefaultDialogTitle } from '../../../../components/styled/Dialog'

const DialogScale = ({
    open,
    setOpen,
    grids,
    setGrids,
    yAxis,
    setYAxis,
}) => {
    const [tempYAxis, setTempYAxis] = useState({})

    useEffect(() => {
        if (open) {
            setTempYAxis({ ...yAxis })
        }
    }, [open, yAxis])

    // Champ vide / non renseigné / non numérique -> undefined (échelle auto). Avant : Number(undefined) = NaN,
    // et NaN n'étant pas "nullish", il écrasait l'auto-échelle (`override ?? auto`) -> axe incohérent.
    const toBound = v => {
        if (v === undefined || v === null || `${v}`.trim() === '') return undefined
        const n = Number(`${v}`.replace(',', '.'))
        return Number.isFinite(n) ? n : undefined
    }

    const onApply = () => {
        const updatedYAxis = {}
        grids.forEach((g, idx) => {
            updatedYAxis[idx + 1] = {
                min: toBound(tempYAxis[idx + 1]?.min),
                max: toBound(tempYAxis[idx + 1]?.max),
            }
        })
        setYAxis(updatedYAxis)
        setOpen(false)
    }

    return (
        <Dialog open={open}>
            <DefaultDialogTitle
                title={i18n.chartScale}
                onClose={() => {
                    setOpen(false)
                    setGrids([])
                }}
            />
            <DialogContent>
                <Card>
                    <CardContent>
                        <Grid container spacing={1}>
                            {grids.map((g, idx) => (
                                <Grid container size={12} key={g.id} alignItems={'center'} spacing={1}>
                                    <Grid size={4}>{g.name}</Grid>
                                    <Grid size={4}>
                                        <Input
                                            title={i18n.min}
                                            value={`${tempYAxis[idx + 1]?.min ?? ''}`}
                                            onChange={(v) => {
                                                setTempYAxis(prev => ({
                                                    ...prev,
                                                    [idx + 1]: {
                                                        ...prev[idx + 1],
                                                        min: v,
                                                    },
                                                }))
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <Input
                                            title={i18n.max}
                                            value={`${tempYAxis[idx + 1]?.max ?? ''}`}
                                            onChange={(v) => {
                                                setTempYAxis(prev => ({
                                                    ...prev,
                                                    [idx + 1]: {
                                                        ...prev[idx + 1],
                                                        max: v,
                                                    },
                                                }))
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            ))}
                        </Grid>
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions style={{ justifyContent: 'right' }}>
                <Button
                    onClick={onApply}
                    variant='contained'
                    color='primary'
                >
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

DialogScale.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    grids: PropTypes.arrayOf(ShapeDataType),
    setGrids: PropTypes.func,
    yAxis: PropTypes.shape({}),
    setYAxis: PropTypes.func,
}

export default DialogScale